<div class="settings-container">
  <!-- Settings Content -->
  <div class="settings-content">
    <!-- Left Column -->
    <div class="settings-column">
      <!-- Profile Section -->
      <section id="profile" class="settings-section section-profile">
        <div class="section-header">
          <h2 class="section-title">Personal Information</h2>
        </div>
        <div class="profile-upload">
          <div class="avatar-preview">{{ userInitials() }}</div>
        </div>
        <form class="form-grid" [formGroup]="profileForm" (ngSubmit)="onUpdateProfile()">
          <div class="form-group">
            <label for="firstName">First Name</label>
            <input type="text" id="firstName" formControlName="firstName" />
          </div>
          <div class="form-group">
            <label for="lastName">Last Name</label>
            <input type="text" id="lastName" formControlName="lastName" />
          </div>
          <div class="form-group full">
            <label for="email">Email Address</label>
            <input type="email" id="email" formControlName="email" />
          </div>
          <div class="form-group">
            <label for="countryCode">Country Code</label>
            <input type="text" id="countryCode" formControlName="countryCode" />
          </div>
          <div class="form-group">
            <label for="phoneNumber">Phone Number</label>
            <input type="tel" id="phoneNumber" formControlName="phoneNumber" />
          </div>
          <button type="submit" class="btn-save" [disabled]="profileForm.invalid">
            Update Profile
          </button>
        </form>
      </section>
    </div>

    <!-- Right Column -->
    <div class="settings-column">
      <!-- Security Section -->
      <section id="security" class="settings-section section-security">
        <div class="section-header">
          <div class="header-text">
            <h2 class="section-title">Security Settings</h2>
          </div>
        </div>
        <form class="form-grid" [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">
          <div class="form-group">
            <label for="newPassword">New Password</label>
            <div class="input-wrapper">
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                id="newPassword"
                placeholder="Min 6 characters"
                formControlName="new"
              />
              <button type="button" class="password-toggle" (click)="togglePassword()">
                @if (passwordVisible) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                } @else {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
                    ></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                }
              </button>
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="input-wrapper">
              <input
                [type]="confirmPasswordVisible ? 'text' : 'password'"
                id="confirmPassword"
                placeholder="Repeat new password"
                formControlName="confirm"
              />
              <button type="button" class="password-toggle" (click)="toggleConfirmPassword()">
                @if (confirmPasswordVisible) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                } @else {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
                    ></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                }
              </button>
            </div>
          </div>
          <button type="submit" class="btn-save">Change Password</button>
        </form>
      </section>

      <!-- Message Configs Section -->
      <section id="configs" class="settings-section section-configs">
        <div class="section-header">
          <div class="header-text">
            <h2 class="section-title">Message Configs</h2>
          </div>
        </div>
        <form class="form-grid" [formGroup]="configForm">
          <div class="form-group">
            <label for="senderIds">Sender IDs</label>
            <input type="text" id="senderIds" formControlName="senderIds" />
          </div>
          <div class="form-group">
            <label for="package">Assigned Package</label>
            <input type="text" id="package" formControlName="package" />
          </div>
        </form>
      </section>
    </div>
  </div>
</div>
